import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ContentProvider } from "@/context/ContentContext";
import { SiteLayout } from "@/components/layout/SiteLayout";
import { ScrollToTop } from "@/components/ScrollToTop";

import Home from "@/pages/Home";
import DigitalEdition from "@/pages/DigitalEdition";
import SchoolDetail from "@/pages/SchoolDetail";
import ListingOptions from "@/pages/ListingOptions";
import ListingQuestionnaire from "@/pages/ListingQuestionnaire";
import BrochureMediaKit from "@/pages/BrochureMediaKit";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import ListingForm from "@/pages/admin/ListingForm";
import SiteContent from "@/pages/admin/SiteContent";
import Countries from "@/pages/admin/Countries";
import MenuManager from "@/pages/admin/MenuManager";
import MediaLibrary from "@/pages/admin/MediaLibrary";

const withLayout = (el) => <SiteLayout>{el}</SiteLayout>;

const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  if (user === null) {
    return <div className="min-h-screen flex items-center justify-center text-slate-500">Loading…</div>;
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <ContentProvider>
          <BrowserRouter>
            <ScrollToTop />
            <Toaster position="top-right" richColors />
            <Routes>
              <Route path="/" element={withLayout(<Home />)} />
              <Route path="/digital-edition" element={withLayout(<DigitalEdition />)} />
              <Route path="/search" element={<Navigate to="/digital-edition" replace />} />
              <Route path="/school/:slug" element={withLayout(<SchoolDetail />)} />
              <Route path="/list-your-school/listing-options" element={withLayout(<ListingOptions />)} />
              <Route path="/list-your-school/listing-questionnaire" element={withLayout(<ListingQuestionnaire />)} />
              <Route path="/list-your-school/brochure-media-kit" element={withLayout(<BrochureMediaKit />)} />
              <Route path="/about" element={withLayout(<About />)} />
              <Route path="/contact" element={withLayout(<Contact />)} />

              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
              <Route path="/admin/listings/new" element={<ProtectedRoute><ListingForm /></ProtectedRoute>} />
              <Route path="/admin/listings/:id/edit" element={<ProtectedRoute><ListingForm /></ProtectedRoute>} />
              <Route path="/admin/content" element={<ProtectedRoute><SiteContent /></ProtectedRoute>} />
              <Route path="/admin/countries" element={<ProtectedRoute><Countries /></ProtectedRoute>} />
              <Route path="/admin/menu" element={<ProtectedRoute><MenuManager /></ProtectedRoute>} />
              <Route path="/admin/media" element={<ProtectedRoute><MediaLibrary /></ProtectedRoute>} />

              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
        </ContentProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
